var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "section",
      {
        staticClass: "d-flex align-items-center hero-section",
        attrs: { id: "hero" },
      },
      [
        _c("div", { staticClass: "hero-pc d-none d-lg-block" }, [
          _c("div", { staticClass: "hero-bg" }),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _c(
              "div",
              { staticClass: "row align-items-center justify-content-center" },
              [
                _c("div", { staticClass: "text-center text-lg-start" }, [
                  _c("div", { staticClass: "hero-text fade-in-up" }, [
                    _c("h1", [
                      _vm._v("39游戏盒子，您的游戏库和随身礼包助手！"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex flex-column flex-sm-row mt-4 download-buttons justify-content-center fade-in-up delay-1",
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass:
                            "btn-primary btn-lg download-btn-bg hero-download-btn",
                          attrs: {
                            href: "https://bbsnewapi.3975bbs.com/common/packageAppLink?advertisingId=348",
                            target: "_blank",
                          },
                        },
                        [_vm._v("游戏盒子下载")]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "scroll-indicator fade-in-up delay-2" }, [
            _c("div", { staticClass: "mouse" }, [
              _c("div", { staticClass: "mouse-wheel" }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "scroll-arrows" }, [
              _c("div", { staticClass: "arrow-down" }),
              _vm._v(" "),
              _c("div", { staticClass: "arrow-down" }),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "hero-mobile d-lg-none" }, [
          _c("div", { staticClass: "hero-mobile-bg" }, [
            _c("img", {
              staticStyle: { width: "100%", height: "100%" },
              attrs: { src: require("@/assets/images/mbg.png"), alt: "" },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "hero-mobile-content" }, [
              _c("div", { staticClass: "hero-mobile-text fade-in-up" }, [
                _c("h1", [_vm._v("39游戏盒子")]),
                _vm._v(" "),
                _c("p", [_vm._v("您的游戏库和随身礼包助手！")]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "hero-mobile-download fade-in-up delay-1" },
                [
                  _c(
                    "a",
                    {
                      staticClass: "mobile-download-btn hero-download-btn",
                      attrs: {
                        href: "https://bbsnewapi.3975bbs.com/common/packageAppLink?advertisingId=352",
                        target: "_blank",
                      },
                    },
                    [_vm._v("游戏盒子下载")]
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }